// extracted by mini-css-extract-plugin
export default {"button":"CopyIco_button__n+fHw"};